import React, { useEffect, useState } from "react";
import { config } from "../../CommonUtils/CommonURLS";
import { CommonAxiosGet } from "../../CommonUtils/CommonAxios";
import { ErrorMessage, Field, Form, FormikProvider, useFormik } from "formik";
import CommonReactTable from "../../CommonUtils/CommonReactTable";
import * as bie from "react-bootstrap";
import Swal from "sweetalert2";
import { useSelector } from "react-redux";
import { GetNocServices } from "../../Reducers/AffiliationCommonservice";
import { getServiceFullName } from "../../CommonUtils/CommonValidations";
export default function CommitteReport() {
  const NocServicesOptions = useSelector((state) => state?.commonMastersReducer?.nocservices);

  const [status, setStatus] = useState([]);
  const [verificationdata, setVerificationdata] = useState([]);
  const [isFetched, setIsFetched] = useState(false);
  const [viewMode, setViewMode] = useState("committee");

  /* =======================
       GET COMMITTEE REPORT
    ========================*/
  function GetCommitteReport(noctype, verification) {
    setIsFetched(false);
    setViewMode("committee");

    CommonAxiosGet(`${config.url.FAC_URL}getInspAllotementReport?nocType=${noctype}&verifyType=${verification}`)
      .then((res) => {
        const data = res?.data?.scode === "01" ? res?.data?.data || [] : [];

        setStatus(data);
        setIsFetched(true);
      })
      .catch(() => {
        setStatus([]);
        setIsFetched(true);
      });
  }

  /* =======================
       VERIFICATION API
    ========================*/
  function GetVerificationStatusReport(noctype, cfmsId) {
    setIsFetched(false);
    setViewMode("verification");

    CommonAxiosGet(`${config.url.FAC_URL}getverificationStatusReport?nocType=${noctype}&verifyType=${InstitutionFormik.values.verification}&cfmsId=${cfmsId}`)
      .then((res) => {
        const data = res?.data?.scode === "01" ? res?.data?.data || [] : [];

        setVerificationdata(data);
        setIsFetched(true);
      })
      .catch(() => {
        setVerificationdata([]);
        setIsFetched(true);
      });
  }

  /* =======================
       FORMIK
    ========================*/
  const InstitutionFormik = useFormik({
    initialValues: {
      nocType: "",
      verification: "",
    },
    onSubmit: () => { },
  });

  /* =======================
       HANDLE GET BUTTON
    ========================*/
  function handleGet() {
    const { nocType, verification } = InstitutionFormik.values;

    if (!nocType || !verification) {
      Swal.fire("Please select NOC Type and Verification Type");
      return;
    }

    GetCommitteReport(nocType, verification);
  }

  const label = InstitutionFormik.values.verification === "def_scrutiny" || InstitutionFormik.values.verification === "online_scrutiny" ? "Designation" : "Department";
  console.log("InstitutionFormik.values.verification", InstitutionFormik.values.verification);
  const StatusColumns = [
    {
      id: "slNo",
      header: "Sl.No",
      cell: ({ row }) => row.index + 1,
      Footer: "Total",
    },
    {
      id: "cfms_id_no",
      header: "CFMS ID",
      accessorKey: "cfms_id_no",
      size: 4,
      meta: { style: { textAlign: "left" } },
    },
    // {
    //     id: "officer_name",
    //     header: "Officer Name",
    //     accessorKey: "officer_name",
    // },

    // {
    //     id: "designation",
    //     header: "Designation",
    //     accessorKey: "designation",
    // },

    // ...(InstitutionFormik.values.verification !== "physical_committee" && InstitutionFormik.values.verification !== "def_scrutiny"
    //     ? [
    //         {
    //             id: "gmail",
    //             header: "Email",
    //             accessorKey: "gmail",
    //         },
    //         {
    //             id: "mobile_no",
    //             header: "Mobile No",
    //             accessorKey: "mobile_no",
    //             meta: { style: { textAlign: "left" } },

    //         },
    //     ]
    //     : []),

    // ...(InstitutionFormik?.values?.verification == "physical_committee" || InstitutionFormik?.values?.verification == "def_scrutiny"
    //     ? [

    // ]
    // : []),

    // {
    //     id: "details",
    //     header: " Officer Details",

    //     cell: ({ row }) => {
    //         const [department, mobile, email,] =
    //             row?.original?.details?.split(",") || [];
    //         return (
    //             <div>
    //                 <div><strong>Officer Name:</strong> {row?.original?.officer_name}</div>

    //                 {InstitutionFormik?.values?.verification === "physical_committee" && (
    //                     <div>
    //                         <strong>Designation:</strong> {row?.original?.designation}
    //                     </div>
    //                 )}
    //                 <div><strong>{label}:</strong> {department}</div>

    //                 <div><strong>Mobile No:</strong> {mobile}</div>
    //                 <div><strong>Email:</strong> {email}</div>

    //             </div>
    //         );
    //     },
    // },
    {
      id: "details",
      header: " Officer Details",
      accessorFn: (row) => {
        const [department, mobile, email] = row?.details?.split(",") || [];
        return `Officer Name: ${row?.officer_name}${row?.verification === "physical_committee" ? `, Designation: ${row?.designation}` : ""
          }, ${label}: ${department}, Mobile No: ${mobile}, Email: ${email}`;
      },
      cell: ({ row }) => {
        const [department, mobile, email] = row?.original?.details?.split(",") || [];
        return (
          <div>
            <div>
              <strong>Officer Name:</strong> {row?.original?.officer_name}
            </div>
            {InstitutionFormik?.values?.verification === "physical_committee" && (
              <div>
                <strong>Designation:</strong> {row?.original?.designation}
              </div>
            )}
            <div>
              <strong>{label}:</strong> {department}
            </div>
            <div>
              <strong>Mobile No:</strong> {mobile}
            </div>
            <div>
              <strong>Email:</strong> {email}
            </div>
          </div>
        );
      },
    },
    {
      id: "team_type",
      header: "Role",
      cell: ({ row }) => {
        const { noc_type, team_type } = row.original;
        const verification = InstitutionFormik.values.verification;

        // EOP / Management
        if (noc_type === "eop" || noc_type === "management") {
          if (team_type === "teamHead") return "Team Head";
          if (team_type === "teamMember") return "Convenor";
        }

        // Shifting + Physical/Virtual Scrutiny
        if (noc_type === "shifting" && (verification === "physical_committee" || verification === "virtual_scrutiny" || verification === "online_scrutiny" || verification === "def_scrutiny")) {
          if (team_type === "teamHead") return "Team Head";
          if (team_type === "teamMember") return "Convenor";
        }

        // Default
        return team_type;
      },
    },

    {
      id: "alloted_count",
      header: "Alloted Colleges",
      accessorKey: "alloted_count",
      meta: { style: { textAlign: "center" } },

      cell: ({ row, getValue }) => (
        <span
          role="button"
          tabIndex={0}
          style={{
            color: "blue",
            cursor: "pointer",
            textDecoration: "underline",
          }}
          onClick={() => GetVerificationStatusReport(row?.original.noc_type, row?.original.cfms_id_no)}
          onKeyDown={(e) => {
            if (e.key === "Enter" || e.key === " ") {
              GetVerificationStatusReport(row?.original.noc_type, row?.original.cfms_id_no);
            }
          }}
        >
          {getValue()}
        </span>
      ),

      Footer: ({ table }) => table.getRowModel().rows.reduce((sum, row) => sum + (Number(row.original.alloted_count) || 0), 0),
    },
  ];

  /* =======================
       VERIFICATION TABLE
    ========================*/
  const VerificationColumns = [
    {
      id: "slNo",
      header: "Sl.No",
      cell: ({ row }) => row.index + 1,
    },
    {
      id: "ub_name",
      header: "University Name",
      accessorKey: "ub_name",
    },
    {
      id: "inst_name",
      header: "Name of the Institute",
      accessorFn: (row) => `${row.inst_name} - ${row.coll_code}`,
      cell: ({ row }) => (
        <span>
          {row?.original?.inst_name} - {row?.original?.coll_code}
        </span>
      ),
    },

    {
      id: "principle_mobile",
      header: "Principal Mobile",
      accessorKey: "principle_mobile",
      meta: { style: { textAlign: "left" } },

      cell: ({ getValue }) => getValue() || "-",
    },
    {
      id: "verification_status",
      header: "Verification Status",
      accessorKey: "verification_status",
      // meta: { style: { textAlign: "left" } },

      cell: ({ getValue }) => (
        <span
          style={{
            color: getValue()?.toLowerCase() === "done" ? "green" : "red",
            fontWeight: "bold",
          }}
        >
          {getValue() || "-"}
        </span>
      ),
    },
  ];
  const NOC_LABEL_MAP = {
    shifting: "Shifting of the Institution",
    eop: "Extension of Permission (EoP)",
    management: "Management Change",
  };

  const VERIFICATION_LABEL_MAP = {
    online_scrutiny: "Online Scrutiny",
    def_scrutiny: "Deficiency Scrutiny",
    physical_committee: "Physical Scrutiny",
    virtual_scrutiny: "Virtual Scrutiny",
  };


  useEffect(() => {
    GetNocServices();
  }, []);
  return (
    <div className="faculty-form-wrapper">
      <div className="faculty-card">
        <h5 className="mb-3 innerheader-new">
          <span> Committee Status Report</span>
        </h5>
        <FormikProvider value={InstitutionFormik}>
          <Form>
            <bie.Row>
              <bie.Col lg={3} className="mb-2">
                <label>NOC Type</label>
                <Field
                  as="select"
                  name="nocType"
                  className="form-control"
                  onChange={(e) => {
                    InstitutionFormik.handleChange(e);
                    InstitutionFormik.setFieldValue("verification", ""); // reset verification too
                    setStatus([]);
                    setVerificationdata([]);
                    setIsFetched(false);
                    setViewMode("committee");
                  }}
                >
                  <option value="">--Select--</option>
                  {/* {Object.entries(NOC_TYPE_MAP).map(([label, value]) => (
                    <option key={value} value={value}>
                      {label}
                    </option>
                  ))} */}
                  {NocServicesOptions
                    ?.filter((service) => service.is_active)
                    .map((service) => (
                      <option
                        key={service.nos_short_name}
                        value={service.nos_short_name}
                      >
                        {service.full_name}
                      </option>
                    ))}
                </Field>
                <ErrorMessage name="nocType" component="div" className="text-danger" />
              </bie.Col>


              {/* VERIFICATION */}
              <bie.Col lg={3} className="mb-2">
                <label>Verification Type</label>
                <Field
                  as="select"
                  name="verification"
                  className="form-control"
                  onChange={(e) => {
                    InstitutionFormik.handleChange(e);
                    setStatus([]);
                    setVerificationdata([]);
                    setIsFetched(false);
                    setViewMode("committee");
                  }}
                >
                  <option value="">--Select--</option>
                  {InstitutionFormik.values.nocType !== "shifting" && (
                    <>
                      <option value="online_scrutiny">Online Scrutiny</option>
                      <option value="def_scrutiny">Deficiency Scrutiny</option>
                    </>
                  )}
                  {/* <option value="physical_committee">
                                        Physical Scrutiny
                                    </option>
                                    <option value="virtual_scrutiny">
                                        Virtual Scrutiny
                                    </option> */}
                  {InstitutionFormik.values.nocType === "shifting" && (
                    <>
                      <option value="online_scrutiny">Online Scrutiny</option>
                      <option value="physical_committee">Physical Scrutiny</option>
                      {/* <option value="virtual_scrutiny">
                                                Virtual Scrutiny
                                            </option> */}
                    </>
                  )}
                </Field>
              </bie.Col>

              {/* GET BUTTON */}
              <bie.Col lg={2} className="mb-2 d-flex align-items-end">
                <button type="button" className="btn btn-success" onClick={handleGet}>
                  GET data
                </button>
              </bie.Col>
            </bie.Row>
          </Form>
        </FormikProvider>

        {/* BACK BUTTON RIGHT SIDE */}
        {viewMode === "verification" && (
          <div className="d-flex justify-content-end mb-3">
            <button
              className="btn btn-secondary"
              onClick={() => {
                setViewMode("committee");
                setVerificationdata([]);
              }}
            >
              ← Back
            </button>
          </div>
        )}

        {/* TABLE RENDER */}
        {!isFetched ? null : viewMode === "committee" ? (
          status?.length > 0 ? (
            <CommonReactTable
              data={status}
              columns={StatusColumns}
              showFooter={true}
              showPagination={false}
              // headerName={`Committee Status Report - ${NOC_LABEL_MAP[InstitutionFormik.values.nocType] || ""} (${VERIFICATION_LABEL_MAP[InstitutionFormik.values.verification] || ""})`}
              headerName={`Committee Status Report - ${getServiceFullName(
                InstitutionFormik.values.nocType,
                NocServicesOptions
              )}${InstitutionFormik.values.verification
                ? ` (${VERIFICATION_LABEL_MAP[InstitutionFormik.values.verification]})`
                : ""
                }`}
            />
          ) : (
            <center className="text-danger">No Committee Data Found</center>
          )
        ) : verificationdata?.length > 0 ? (
          <CommonReactTable
            data={verificationdata}
            columns={VerificationColumns}
            showPagination={false}
            showFooter={false}
            excelFileName="Verification_Report"
            headerName="Verification Status Report"
          />
        ) : (
          <center className="text-danger">No Verification Data Found</center>
        )}
      </div>
    </div>
  );
}
